import { ReactNode } from 'react';
// form
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  id?: string;
  onSubmit?: VoidFunction;
  style?: React.CSSProperties;
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  id,
  style,
}: Props) {
  return (
    <Form {...methods}>
      <form id={id} onSubmit={onSubmit} style={style}>
        {children}
      </form>
    </Form>
  );
}
